<template>
  <div></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import logHandler from '../mixins/logHandler'

export default {
  name: 'data-manager',

  mixins: [logHandler],

  // First being called, on init, once.
  // Add event listenings here
  async mounted() {
    // Add events listeners
    this.$root.$on('get-current-results', this.getCurrentResultsHandler)
    this.$root.$on('update-mission-list', this.updateMissionListHandler)
    this.$root.$on('create-mission', this.createMissionHandler)
    this.$root.$on('copy-mission', this.copyMissionHandler)
    this.$root.$on('delete-mission', this.deleteMissionHandler)
    this.$root.$on('set-current-mission', this.setCurrentMissionHandler)
    this.$root.$on('base-object-updated', this.baseObjectUpdatedHandler)
    this.$root.$on('current-mission-updated', this.currentMissionUpdatedHandler)
    this.$root.$on('update-groups-list', this.updateGroupsListHandler)
    this.$root.$on('update-options-list', this.updateOptionsListHandler)
    // Initialization
    await this.loadMissions(this.$root)
    if (
      localStorage.currentMissionId &&
      localStorage.currentMissionId !== 'null'
    ) {
      let [typeName, id] = localStorage.currentMissionId.split('|')
      if (!typeName || !id) {
        return
      }
      let mission = this.missions.find((el) => el.id === id && typeName)
      if (!mission) {
        mission = await this.getMission(id, typeName)
      }
      if (mission) {
        await this.setCurrentMission(mission)
        this.$nextTick(() => {
          this.$root.$emit('current-mission-updated')
        })
      }
    }
    if (
      localStorage.currentResultsId &&
      localStorage.currentResultsId !== 'null'
    ) {
      let id = localStorage.currentResultsId
      if (!(this.currentMission.id === id)) {
        localStorage.currentResultsId = this.currentMission.id
      }
      await this.loadResultsLog(this.$root)
    }
  },

  // Called before rerender (anything changed)
  beforeUpdate() {},

  // Called after rerender
  updated() {},

  beforeDestroy() {
    this.$root.$off('get-current-results', this.getCurrentResultsHandler)
    this.$root.$off('update-mission-list', this.updateMissionListHandler)
    this.$root.$off('create-mission', this.createMissionHandler)
    this.$root.$off('copy-mission', this.copyMissionHandler)
    this.$root.$off('delete-mission', this.deleteMissionHandler)
    this.$root.$off('set-current-mission', this.setCurrentMissionHandler)
    this.$root.$off('base-object-updated', this.baseObjectUpdatedHandler)
    this.$root.$off(
      'current-mission-updated',
      this.currentMissionUpdatedHandler
    )
    this.$root.$off('update-groups-list', this.updateGroupsListHandler)
    this.$root.$off('update-options-list', this.updateOptionsListHandler)
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      missions: 'missions',
      currentMission: 'currentMission',
      currentResultsLog: 'currentResultsLog'
    })
  },

  methods: {
    ...mapActions([
      'loadMissions',
      'setCurrentMission',
      'loadResultsLog',
      'resetResultsLog',
      'loadUserGroups',
      'loadOptions'
    ]),

    async getCurrentResultsHandler() {
      if (this.currentMission) {
        await this.loadResultsLog(this.$root)
      }
    },
    async updateMissionListHandler() {
      await this.loadMissions(this.$root)
    },
    async createMissionHandler() {
      await this.loadMissions(this.$root)
    },
    async copyMissionHandler() {
      await this.loadMissions(this.$root)
    },
    async deleteMissionHandler() {
      await this.loadMissions(this.$root)
    },
    async setCurrentMissionHandler(mission) {
      this.resetResultsLog(this.$root)
      await this.setCurrentMission(mission)
      this.$nextTick(async () => {
        this.$root.$emit('current-mission-updated')
      })
    },
    async baseObjectUpdatedHandler() {
      await this.loadMissions(this.$root)
    },
    async currentMissionUpdatedHandler() {
      this.$root.$emit('get-current-results')
      await this.loadMissions(this.$root)
    },
    async updateGroupsListHandler() {
      await this.loadUserGroups()
    },
    async updateOptionsListHandler() {
      await this.loadOptions()
    },

    async getMission(missionId, missionType) {
      let user = this.currentUser
      if (!user) {
        return
      }
      try {
        let mission = await this.$http.get(
          `users/${user.id}/${missionType.toLowerCase() + 's'}/${missionId}`
        )
        return await mission.data
      } catch (e) {
        this.displayMessage(
          'Failed to load mission ',
          e,
          'notifications',
          'error'
        )
        return null
      }
    }
  }
}
</script>
